import { TOGGLE_LOCALE, DELETE_LOCALE } from '../constants/actionTypes';

export function toggleLocale(text) {
  return { type: TOGGLE_LOCALE, text };
}

export function deleteLocale(index) {
  return { type: DELETE_LOCALE, index };
}
